import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Divider from '@mui/material/Divider';
import CardHeader from '@mui/material/CardHeader';

import {
  addressDetailsData,
  BankDetailsData,
  personalDetailsData,
  professionalDetailsData,
} from './util/profileDetails';
import ProfileCard from './components/ProfileCard';
import { useDispatch, useSelector } from 'react-redux';
import { getProfileGeneral } from '../../../../../redux/features/generalSlice';
import Loader from '../../../../../components/Loader/Loader';
import { chatPhotoUrl } from '../../../../../utils/constants/links';

const EmployeeProfile = () => {
  const [tab, setTab] = useState(0);
  const dispatch = useDispatch();
  const { user, loading } = useSelector((state) => state.general);

  useEffect(() => {
    dispatch(getProfileGeneral());
    // return () => dispatch(clearProfile());
  }, []);

  const tabsArray = [addressDetailsData, professionalDetailsData, BankDetailsData];

  return loading ? (
    <Loader />
  ) : (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          height: 200,
          borderRadius: '60px 0 60px 0',
          background: 'url("/static/EmployeeProfileBanner.webp")',
          display: 'flex',
          alignItems: 'center',
          p: 3,
          color: '#fff',
          mb: 3,
        }}
      >
        <Avatar
          sx={{
            width: 100,
            height: 100,
            mr: 2,
            bgcolor: '#cfd8dc',
            color: '#000',
            fontSize: 32,
          }}
          src={`${chatPhotoUrl}/${user?.photo}.jpg`}
        />

        <Box>
          <Typography variant="h6">{user?.name}</Typography>
          <Typography variant="body1" sx={{ opacity: 0.8 }}>
            {user?.designationName}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            {`EMP ID : ${user?.empId}`}
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <Card sx={{ minHeight: { xs: '100%', sm: 380 } }}>
            <CardHeader title={'Personal Details'} />
            <Divider sx={{ mt: 1 }} />
            <CardContent>
              <ProfileCard keyValue={personalDetailsData} data={user} />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={7}>
          <Card sx={{ minHeight: { xs: '100%', md: 380 } }}>
            <Tabs sx={{ pt: 1.5 }} value={tab} onChange={(_, v) => setTab(v)} variant="scrollable">
              <Tab label="Address" />
              <Tab label="Professional" />
              <Tab label="Bank" />
            </Tabs>

            <Divider />

            <CardContent>{<ProfileCard keyValue={tabsArray[tab]} data={user} />}</CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmployeeProfile;
